import * as React from 'react'
import styled, { css } from 'styled-components'

import Modal from '../../ui/Modal/Modal'

import * as ExploreApiService from '../../../services/api/requests/Explore'

const Container = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
`

const Title = styled.h1`
  margin: 0;
  text-transform: uppercase;
  font-size: 1.5rem;
`

const SubTitle = styled.h3`
  font-size: 1rem;
  font-weight: var(--font-weight);
  margin-top: 0;
  color: var(--color-fg-light);
`

const Body = styled.div`
  > p {
    &:first-child {
      margin-top: 0;
    }
  }

  margin-bottom: 2rem;
`

const MerchantsList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`

const MerchantsListItem = styled.li`
  display: flex;
  padding: 1rem;
  border-top: 1px solid var(--color-fg-lighter);
  cursor: pointer;

  &:last-child {
    border-bottom: 1px solid var(--color-fg-lighter);
  }

  &:hover {
    background: var(--color-bg-hover);
  }
`

const MerchantLogo = styled.div.attrs(props => ({
  style: {
    background: `url('${props.logoUrl}') no-repeat center / contain`,
  },
}))`
  width: 50px;
  min-height: 50px;
  margin-right: 1rem;
`

const MerchantDetails = styled.div`
  display: flex;
  flex-direction: column;
`

const MerchantName = styled.h3`
  margin: 0;
`

const MerchantLocation = styled.p`
  margin: 0;
`

const MallLogo = styled.div`
  ${props =>
    props.iconUrl &&
    css`
    background: url('${props.iconUrl}');
  `}
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 150px;
  min-height: 150px;
`

function MerchantsListModal(props) {
  const {
    show = false,
    shareUrl,
    onClose,
    data = [],
    setMerchantsListModalData,
    setStoreModalData,
    showStoreModal,
    ...restProps
  } = props

  const mallLogo = !!data.length && data[0].mall.iconUrl

  const selectMerchant = merchantItemId => {
    ExploreApiService.getStore(merchantItemId)
      .then(response => {
        setStoreModalData(response.data)
      })
      .catch(() => {})
  }

  return (
    <Modal
      id="MerchantsListModal"
      show={show}
      handleClose={e => {
        e.stopPropagation()
        setMerchantsListModalData([])
      }}
      {...restProps}
    >
      <Container>
        <MallLogo iconUrl={mallLogo} />
        <Title>Participating Merchants</Title>
        <SubTitle>
          View details of participating merchants under this promo.
        </SubTitle>
        <Body>
          <MerchantsList>
            {data.map(merchantItem => (
              <MerchantsListItem
                onClick={() => selectMerchant(merchantItem.id)}
              >
                <MerchantLogo logoUrl={merchantItem.merchant.logoUrl} />
                <MerchantDetails>
                  <MerchantName>{merchantItem.merchant.name}</MerchantName>
                  <MerchantLocation>{merchantItem.floor}</MerchantLocation>
                </MerchantDetails>
              </MerchantsListItem>
            ))}
          </MerchantsList>
        </Body>
      </Container>
    </Modal>
  )
}

export default MerchantsListModal
